import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sf-form-group tw-pb-4 md:tw-grid md:tw-grid-cols-2 md:tw-gap-4" }
const _hoisted_2 = { class: "!tw-inline md:tw-block" }
const _hoisted_3 = { class: "!tw-inline md:tw-block" }
const _hoisted_4 = {
  key: 0,
  class: "tw-pt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, " How many " + _toDisplayString(_ctx.subject) + " classes do you wish to " + _toDisplayString(_ctx.labelAction) + "? ", 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.renderMoney(_ctx.classCost)) + " / class ", 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'tw-grid tw-grid-cols-2 tw-gap-4': _ctx.mode == 'addclasses' })
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classCount) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.evaluateMinClasses && _ctx.evaluateMinClasses(...args))),
        class: "sf-form-control tw-w-full",
        min: "0"
      }, null, 544), [
        [_vModelText, _ctx.classCount]
      ]),
      (_ctx.mode == 'addclasses')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.totalCount) + " classes in total ", 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}